import React, { useRef, useState } from 'react';
import { compose } from 'ramda';
import { branch } from 'recompose';

import { clsx } from 'js/app/utils/clsx.util';
import { useMountEffect } from 'js/hooks/useMountEffect';
import buildClassName from 'js/utils/classNameBuilder.util';
import { withManyErrors } from 'js/components/common/Fields/ErrorMessage';

import style from './index.scss';

export const ErrorMessage = ({ error, classNames = {}, className = '', isFormError, isAbsolute, animate = true }) => {
    const messageRef = useRef(null);
    const [isHoverEffect, setHoverEffect] = useState(false);
    const errorStyles = clsx(
        className,
        'ErrorMessage__error',
        buildClassName(['error'], style, classNames),
        {
            [style.isHoverEffect]: isHoverEffect,
            [classNames?.isHoverEffect]: classNames?.isHoverEffect && isHoverEffect,
            [style.isFormError]: isFormError,
            [style.isAbsolute]: isAbsolute,
            slideInDown: animate
        }
    );

    useMountEffect(isMounted => {
        if (isHoverEffect) {
            return;
        }

        if (isMounted() && messageRef.current.scrollWidth > messageRef.current.offsetWidth) {
            setHoverEffect(true);
        }
    }, [messageRef, error]);

    return (
        <div
            ref={messageRef}
            className={errorStyles}
            dangerouslySetInnerHTML={{ __html: error }}
            data-testid="ErrorMessage__error"
        />
    );
};

export default compose(
    branch(
        ({ error }) => error instanceof Array,
        withManyErrors
    )
)(ErrorMessage);
